import { InputMatrixParameterValue } from "../../../../../../api/models/test-request/TestRequestInputMatrix";

interface HotCoordinate {
  row: number;
  column: number;
}

const gatherParameterValues = (parameterValues: { [name: string]: InputMatrixParameterValue }) => {
  return Object.keys(parameterValues).map((key) => parameterValues[key].value);
};

const gatherParameterKeys = (parameterValues: { [name: string]: InputMatrixParameterValue }) => {
  return Object.keys(parameterValues);
};

const gatherParameterEntries = (parameterValues: { [name: string]: InputMatrixParameterValue }) => {
  return Object.entries(parameterValues);
};

export type { HotCoordinate };
export { gatherParameterEntries, gatherParameterKeys, gatherParameterValues };
